<template>
  <Loader v-if="isDataLoading"/>
  <div v-else>
      <Table
        :title="$t('views.snapshots.title')"
        :headers="snapshotsHeaders"
        :rows="snapshotsRows"
        :values="snapshots"/>
  </div>

</template>

<script>
import VEEAM from '@/api/veeam';
import Table from '@/components/Table.vue';
import Loader from '@/components/Loader.vue';

import moment from 'moment';

export default {
  name: 'snapshots',
  components: {
    Table,
    Loader,
  },
  data() {
    return {
      snapshots: [],
      isDataLoading: true,
      snapshotsHeaders: [
        {
          label: this.$t('views.snapshots.config.snapshotsHeaders.name'),
          field: 'vm_name',
        },
        {
          label: this.$t('views.snapshots.config.snapshotsHeaders.created'),
          field: 'created',
        },
        {
          label: this.$t('views.snapshots.config.snapshotsHeaders.ended'),
          field: 'ended',
        },
        {
          label: this.$t('views.snapshots.config.snapshotsHeaders.size'),
          field: 'size',
        },
        {
          label: this.$t('views.snapshots.config.snapshotsHeaders.result'),
          field: 'result',
        },
        {
          label: this.$t('views.snapshots.config.snapshotsHeaders.state'),
          field: 'state',
        },
        {
          label: this.$t('views.snapshots.config.snapshotsHeaders.reason'),
          field: 'reason',
        },
        {
          label: this.$t('views.snapshots.config.snapshotsHeaders.job'),
          field: 'job_type',
        },
      ],
      snapshotsRows: [
        {
          value: row => row.vm_name,
        },
        {
          value: row => moment(row.created).format('DD/MM/YYYY hh:mm:ss'),
        },
        {
          value: row => moment(row.ended).format('DD/MM/YYYY hh:mm:ss'),
        },
        {
          value: row => row.size,
        },
        {
          value: row => row.result,
        },
        {
          value: row => row.state,
        },
        {
          value: row => row.reason,
        },
        {
          value: row => row.job_type,
        },
      ],
    };
  },
  computed: {
  },
  created() {
    moment.locale(this.$i18n.locale);
    this.getSnapshots();
  },
  mounted() {

  },
  methods: {
    getSnapshots() {
      VEEAM.list().then((res) => {
        this.isDataLoading = false;
        this.snapshots = res.data;
      }, (err) => {
        this.isDataLoading = false;
      });
    },
  },
};
</script>
